var productFill = 0;
const settings = {
  moneyFormat: window.theme.currencyCodeEnabled
    ? window.theme.moneyWithCurrencyFormat
    : window.theme.moneyFormat,
  rules: {
    minStones: 1,
    maxStones: 10,
    minCharms: 1,
    maxCharms: 1,
    maxFill: 80,
  },
  cart: {
    rules: {
      minStones: 3,
      maxStones: 10,
      minCharms: 1,
      maxCharms: 1,
      maxFill: 80
    },
  },
};

const { Bodies, Body, Composite, Composites, Engine, Events, World, Runner, Svg, Common, Render } = Matter;
let ballRadius = 100;
let pegCount = 32;
let pegSize = 40;
let maximumBalls = 200;
let ballEveryNFrames = 5;
let m = 50;
let engine, runner, canvas, wheel;
imageMapResize();

var select = function (root, selector) {
  return Array.prototype.slice.call(root.querySelectorAll(selector));
};

var loadSvg = function (url) {
  return fetch(url)
    .then(function (response) {
      return response.text();
    })
    .then(function (raw) {
      return new window.DOMParser().parseFromString(raw, "image/svg+xml");
    });
};

function addBody(...bodies) {
  Composite.add(iEngine.world, ...bodies);
}

function removeBody(...bodies) {
  World.remove(engine.world, ...bodies);
}

function addRect({ x = 0, y = 0, w = 10, h = 10, options = {} } = {}) {
  let body = Bodies.rectangle(x, y, w, h, options);
  addBody(body);
  return body;
}

function addCircle({ x = 0, y = 0, r = 10, options = {} } = {}) {
  let body = Bodies.circle(x, y, r, options);
  addBody(body);
  return body;
}

function showLoader(state) {
  if (state == 'show') {
    document.getElementsByClassName("MainProduct__Loader")[0].style.display = 'block';
  } else {
    document.getElementsByClassName("MainProduct__Loader")[0].style.display = 'none';
    return false
  }
}


function drawObject(variant = null, quantity = 1) {
  if (variant == null) return;
  const svgProduct = document.querySelector(`.additional-svgs__product[data-variant="${variant}"]`);
  if (!svgProduct) return;
  const svgProductCode = svgProduct.querySelector('svg path');
  const imgObj = new Image();
  showLoader('show')
  imgObj.src = svgProduct.dataset.texture;
  imgObj.onload = () => {
    for (let i = 0; i < quantity; i++) {
      var obj = Matter.Bodies.fromVertices(200, 75, Matter.Svg.pathToVertices(svgProductCode), { 
        label: `obj_${variant}`,
        render: {
          strokeStyle: '#000',
          sprite: {
            texture: imgObj.src
          }
        }
      }, true);
      showLoader('hide')
      addBody(obj);
    }
  };
}

// Renderer
const iEngine = Engine.create();
const iRunner = Runner.create();
const iRender = Render.create({
  element: document.querySelector('.MainProduct__ImageCanvas'),
  engine: iEngine,
  options: {
    width: 400,
    height: 400,
    wireframes: false,
    background: "transparent"
  }
});
Render.run(iRender);
Runner.run(iRunner, iEngine);

// Create wheel
m = 600;
let rat = 1 / 3;
let r = m * rat;
let parts = [];

for (let i = 0; i < pegCount; i++) {
  const TAU = Math.PI * 2;
  let segment = TAU / pegCount;
  let angle = i / pegCount * TAU + segment / 2;
  let x = Math.cos(angle);
  let y = Math.sin(angle);
  let cx = x * r;
  let cy = y * r;
  let rect = addRect({ x: cx + 200, y: cy + 200, w: 10 / 1000 * m, h: 60 / 1000 * m, 
    options: { 
      angle: angle, 
      isStatic: true,
      render: {
        opacity: 0
      }
    } 
  });
  parts.push(rect);
}
wheel = Body.create({ parts, isStatic: true });

class Configurator {
  constructor(cart) {
    this.cart = cart;
    this.configurator = window.configurator;
    this.element = document.querySelector(".Configurator");

    this.groupProductVariants();
    this.render();
    this.addListeners();
  }

  groupProductVariants() {
    this.productsVariantsGrouped = {};
    const otherLabel = this.element.dataset.configuratorOtherLabel;

    for (const product of Object.values(this.configurator.products)) {
      const colorPosition = product.color?.position;

      product.variants.forEach((variant) => {
        if (!variant.available) return;
        variant.product_id = product.id;
        if (colorPosition) {
          const color = variant[`option${colorPosition}`];

          if (!color) return;

          if (!this.productsVariantsGrouped[color]) {
            this.productsVariantsGrouped[color] = [variant];
          } else {
            this.productsVariantsGrouped[color].push(variant);
          }
        } else {
          if (!this.productsVariantsGrouped[otherLabel]) {
            this.productsVariantsGrouped[otherLabel] = [variant];
          } else {
            this.productsVariantsGrouped[otherLabel].push(variant);
          }
        }
      });
    }
  }

  addListeners() {
    this.delegeatedElement = new domDelegate.Delegate(this.element);

    this.delegeatedElement.on(
      "click",
      "[data-action='select-product']",
      (event) => this.handleSelectProduct(event)
    );

    this.delegeatedElement.on(
      "click",
      "[data-action='reset-product']",
      () => this.cart.clear()
    );

    this.delegeatedElement.on(
      "click",
      "[data-action='undo-product']",
      () => this.undoProduct()
    );

    this.delegeatedElement.on(
      "click",
      "[data-action='change-the-stones']",
      (event) => {
        event.preventDefault();

        const navLink = document.querySelector('.Configurator .Header__Navigation ul li:nth-child(2) a');
        navLink && navLink.dispatchEvent(new Event('click'));
      }
    );

    this.delegeatedElement.on(
      "click",
      "[data-action='change-the-necklace']",
      (event) => {
        event.preventDefault();

        const navLink = document.querySelector('.Configurator .Header__Navigation ul li:nth-child(1) a');
        navLink && navLink.dispatchEvent(new Event('click'));
      }
    );   

    this.delegeatedElement.on(
      "click",
      ".MobileProducts__Category .Product",
      (event) => this.mobilePreview(event)
    );

    this.delegeatedElement.on(
      "click",
      "[data-action='open-gallery']",
      (event) => this.openGallery(event)
    );

    this.delegeatedElement.on(
      "click",
      ".Configurator .Gallery__Close",
      (event) => this.closeGallery(event)
    );

    this.delegeatedElement.on(
      "click",
      ".Configurator .Gallery",
      (event) => (event.target.classList.contains('Gallery')) && this.closeGallery(event)
    );

    this.delegeatedElement.on(
      "click",
      ".Sidebar__Product [data-action='decrease-quantity']",
      (event) => {
        const sidebarProduct = event.target.closest(".Sidebar__Product");
        const addToCartElement = sidebarProduct.querySelector(
          "[data-action='select-product']"
        );
        const currentQuantity = Number(addToCartElement.dataset.quantity);

        if (currentQuantity === 1) return;
        event.target.parentNode.querySelector(".Quantity__Value").innerText =
          currentQuantity - 1;
        addToCartElement.dataset.quantity = currentQuantity - 1;
      }
    );

    this.delegeatedElement.on(
      "click",
      ".Sidebar__Product [data-action='increase-quantity']",
      (event) => {
        try {
          const sidebarProduct = event.target.closest(".Sidebar__Product");
          const addToCartElement = sidebarProduct.querySelector(
            "[data-action='select-product']"
          );
          const currentQuantity = Number(addToCartElement.dataset.quantity);
          const productType = addToCartElement.dataset.type;
          const fill = Number(addToCartElement.dataset.fill);

          if ( productType === "stone" && Number(this.cart.productFill) + (currentQuantity + 1)*fill > settings.rules.maxFill ) {
            throw new Error(
              `${window.configurator_content?.maxFillStones}`
            );
          }

          // if (
          //   productType === "stone" &&
          //   this.cart.getStonesQuantity() + currentQuantity + 1 >
          //     settings.rules.maxStones
          // )
          //   throw new Error(
          //     `${window.configurator_content?.maxStones} ${settings.rules.maxStones}`
          //   );

          event.target.parentNode.querySelector(".Quantity__Value").innerText =
            currentQuantity + 1;
          addToCartElement.dataset.quantity = currentQuantity + 1;
        } catch (error) {
          alert(error.message);
        }
      }
    );

    this.delegeatedElement.on(
      "click",
      ".MobileModal__Close",
      () => this.closeMobilePreview()
    );

    this.delegeatedElement.on(
      "click",
      ".MobileModal__QuantityButton",
      (event) => {
        const modalWrapper = event.target.closest('.MobileModal__Action');
        const quantityInput = modalWrapper.querySelector('.MobileModal__QuantityValue');
        const error = modalWrapper.querySelector('.MobileModal__Error');
        const button = modalWrapper.querySelector('.Button');
        const action = event.target.dataset.action;
        const fill = Number(button.dataset.fill);
        let quantity = Number(quantityInput.innerHTML);

        if (action === 'increase-quantity') {

          if ( Number(this.cart.productFill) + (quantity + 1)*fill > settings.rules.maxFill ) {
            error.innerHTML = `${window.configurator_content?.maxFillStones}`
            return;
          }
          quantity += 1;
        }
        if (action === 'decrease-quantity' && (Number(quantityInput.innerHTML) - 1) > 0) {
          quantity -= 1;
        }
        if (error) {
          error.innerHTML = '';
        }
        quantityInput.innerHTML = quantity;
        button.dataset.quantity = quantity;
      }
    );

    this.delegeatedElement.on(
      "click",
      ".Configurator .Cart__MobileDrawer, .Configurator .Cart__TotalMessage",
      (event) => {
        event.preventDefault();

        const cart = document.querySelector('.Configurator .Sidebar--right');
        cart.classList.add('active');
      }
    );

    this.delegeatedElement.on(
      "click",
      ".Configurator .Sidebar--right .Sidebar__Close",
      (event) => {
        event.preventDefault();

        const cart = document.querySelector('.Configurator .Sidebar--right');
        cart.classList.remove('active');
      }
    );
  }

  handleSelectProduct(event) {
    const product_type = event.target.dataset.type;
    const quantity = Number(event.target.dataset.quantity);
    const variant = Number(event.target.dataset.variant);
    
    if (product_type === "product") {
      const succeed = this.cart.add({
        quantity,
        product_type,
        variant
      });

      if (!succeed) return;

      const variantID = event.target.dataset.variant;
      const productElement = document.querySelector(`.Sidebar__Product[data-variant='${variantID}']`);

      if (productElement.classList.contains("active")) return;

      document.querySelector(".Sidebar__Product.active").classList.remove("active");
      productElement.classList.add("active");

      this.configurator.main_variant = this.configurator.variants.find(
        (variant) => variant.id == variantID
      );

      this.closeGallery();
      this.closeMobilePreview();
      this.renderMainProduct();
    }

    if (product_type === "stone" || product_type === "charm") {

      const fill = Number(event.target.dataset.fill);
      const succeed = this.cart.add({
        quantity,
        product_type,
        variant,
        fill,
      });
      if (!succeed) return;
      drawObject(variant, quantity);
      this.closeMobilePreview();
    }
  }

  renderMainProduct() {
    const mainProductElement = document.querySelector(".MainProduct__Wrapper");
    const mainProductImageElement = mainProductElement.querySelector(".MainProduct__Image");

    mainProductImageElement.removeAttribute("data-src");
    if (this.configurator.main_variant.featured_image) {
      mainProductImageElement.dataset.src = this.configurator.main_variant.featured_image.src;
      window.lazySizes.loader.unveil(mainProductImageElement);
    }
  }

  render() {
    this.renderProducts();
    this.renderStones();
    this.renderCharms();
  }

  renderProducts() {
    const element = this.element.querySelector(
      ".Sidebar--products .Sidebar__Inner"
    );

    for (const [title, variants] of Object.entries(
      this.productsVariantsGrouped
    )) {
      const headerSmallElemet = document.createElement("div");
      headerSmallElemet.classList.add("Sidebar__Header--small");

      const titleElement = document.createElement("h3");
      titleElement.classList.add("Title");

      titleElement.innerText = title;
      headerSmallElemet.appendChild(titleElement);
      element.appendChild(headerSmallElemet);

      const listElement = document.createElement("ul");
      listElement.classList.add("Sidebar__List");
      listElement.dataset.color = title;

      element.appendChild(listElement);

      variants.forEach((variant) => {
        const productElement = element.querySelector(
          `.Sidebar__Product:is([data-variant='${variant.id}'], [data-product='${variant.id}'])`
        );

        if (!productElement) return;

        const productElementClone = productElement.cloneNode(true);
        productElement.remove();
        productElementClone.style.display = "block";
        productElementClone.dataset.variant = variant.id;

        if (this.configurator.main_variant.id == variant.id)
          productElementClone.classList.add("active");

        listElement.appendChild(productElementClone);
        this.createTooltip(productElementClone);
      });
    }
  }

  renderStones() {
    const element = this.element.querySelector(
      `.Sidebar--stones .Sidebar__Inner`
    );

    const listElement = document.createElement("ul");
    listElement.classList.add("Sidebar__List", "Sidebar__List--grid");
    element.appendChild(listElement);

    for (const product of Object.values(this.configurator.stones)) {
      product.variants.forEach((variant) => {
        const productElement = element.querySelector(
          `.Sidebar__Product:is([data-variant='${variant.id}'], [data-product='${product.id}'])`
        );

        if (!productElement) return;

        const productElementClone = productElement.cloneNode(true);
        productElement.remove();
        productElementClone.style.display = "block";
        productElementClone.dataset.variant = variant.id;

        if (this.configurator.main_variant.id == variant.id)
          productElementClone.classList.add("active");

        listElement.appendChild(productElementClone);
        this.createTooltip(productElementClone);
        this.createTooltipError(productElementClone);
      });
    }
  }

  renderCharms() {
    const element = this.element.querySelector(
      `.Sidebar--stones .Sidebar__Inner:last-of-type`
    );

    const listElement = document.createElement("ul");
    listElement.classList.add("Sidebar__List", "Sidebar__List--grid");
    element.appendChild(listElement);

    for (const product of Object.values(this.configurator.charms)) {
      product.variants.forEach((variant) => {
        const productElement = element.querySelector(
          `.Sidebar__Product:is([data-variant='${variant.id}'], [data-product='${product.id}'])`
        );

        if (!productElement) return;

        const productElementClone = productElement.cloneNode(true);
        productElement.remove();
        productElementClone.style.display = "block";
        productElementClone.dataset.variant = variant.id;

        if (this.configurator.main_variant.id == variant.id)
          productElementClone.classList.add("active");

        listElement.appendChild(productElementClone);
        this.createTooltip(productElementClone);
        this.createTooltipError(productElementClone);
      });
    }
  }

  undoProduct() {
    const products = iEngine.world.bodies.filter(i => i.label !== 'Rectangle Body');

    if (products.length > 0) {
      const lastItem = products[products.length - 1]; 
      const variantId = Number(lastItem.label.split('_')[1]);
      const cartItem = this.cart.cart.items.filter(item => item.variant.id === variantId);

      if (cartItem.length === 0) return;
       
      if (cartItem[0].quantity > 1) {
        this.cart.updateQuantity(variantId, "decrease");
      } else {
        this.cart.remove(cartItem[0])
      }
    }
  }

  createTooltip(element) {
    const tooltipElement = element.querySelector(".Tooltip--main");

    if (!tooltipElement) return;

    const popperInstance = Popper.createPopper(
      element.querySelector(".Product__Inner"),
      tooltipElement,
      {
        placement: "right",
        offset: [0, 8],
      }
    );

    function show() {
      if (element.classList.contains("disabled")) return;

      tooltipElement.setAttribute("data-show", "");

      popperInstance.update();
    }

    function hide() {
      tooltipElement.removeAttribute("data-show");
    }

    const showEvents = ["mouseenter", "focus"];
    const hideEvents = ["mouseleave", "blur"];

    showEvents.forEach((event) => {
      element.addEventListener(event, show);
    });

    hideEvents.forEach((event) => {
      element.addEventListener(event, hide);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          if (element.classList.contains("disabled")) {
            hide();
          }
        }
      });
    });

    observer.observe(element, {
      attributes: true,
    });
  }

  createTooltipError(element) {
    const tooltipElement = element.querySelector(".Tooltip--error");

    if (!tooltipElement) return;

    const handledErrors = JSON.parse(tooltipElement.dataset.errors);

    const popperInstance = Popper.createPopper(
      element.querySelector(".Product__Inner"),
      tooltipElement,
      {
        placement: "right",
        offset: [0, 8],
      }
    );

    const show = () => {
      if (!this.cart.errors) return;

      const errors = this.cart.errors.filter((error) =>
        handledErrors.includes(error.name)
      );

      if (errors.length === 0) return;

      tooltipElement.querySelector(".Tooltip__Inner").innerHTML = errors.map((error) => error.message).join("<br>");
      tooltipElement.setAttribute("data-show", "");
      popperInstance.update();
    };

    const hide = () => {
      tooltipElement.removeAttribute("data-show");
    };

    const showEvents = ["mouseenter", "focus"];
    const hideEvents = ["mouseleave", "blur"];

    document.addEventListener("errorsChanged", () => {
      const errors = this.cart.errors.filter((error) =>
        handledErrors.includes(error.name)
      );

      if (errors.length === 0) {
        element.classList.remove("disabled");
      }

      if (errors.length > 0) {
        element.classList.add("disabled");
      }
    });

    showEvents.forEach((event) => {
      element.addEventListener(event, show);
    });

    hideEvents.forEach((event) => {
      element.addEventListener(event, hide);
    });
  }

  openGallery(event) {
    const el = {
      gallery: document.querySelector('.Configurator .Gallery'),
      inner: document.querySelector('.Configurator .Gallery__Slideshow'),
      title: document.querySelector('.Configurator .Gallery__ProductTitle'),
      button: document.querySelector('.Configurator .Gallery__ProductButton')
    };
    const productId = Number(event.target.dataset.product);
    const variantId = Number(event.target.dataset.variant);
    const product = window.configurator.products[productId];
    let galleryHtml = '';

    if (product) {
      for (let i = 0; i < product.images.length; i++) {
        const image = 'https:' + product.images[i];
        galleryHtml += `<div class="Gallery__SlideshowItem"><img src="${image}" alt="${product.title}"></div>`;
      }
      window.configurator.gallery && window.configurator.gallery.destroy();
      el.inner.innerHTML = galleryHtml;

      window.configurator.gallery = new Flickity(el.inner, {
        contain: true,
        adaptiveHeight: true,
        pageDots: false
      });
      
      el.title && (el.title.innerHTML = product.title);
      el.button && (el.button.dataset.variant = variantId);
      el.gallery.classList.add('visible');
    }
  }

  closeGallery(event = null) {
    event && event.preventDefault();

    const gallery = document.querySelector('.Configurator .Gallery');
    gallery && gallery.classList.remove('visible');
  }

  mobilePreview(event = null) {
    if (event === null) return;
    event.preventDefault();

    const product = event.target.closest('.Product') || event.target;
    const productTitle = product.querySelector('.Product__Title');
    const category = product.closest('.MobileProducts__Category');
    const modal = {
      el: document.querySelector('.MobileModal'),
      header: document.querySelector('.MobileModal__Header p'),
      gallery: document.querySelector('.MobileModal__Gallery'),
      productTitle: document.querySelector('.MobileModal__ProductTitle'),
      productSubtitle: document.querySelector('.MobileModal__ProductSubtitle'),
      quantityWrapper: document.querySelector('.MobileModal__Quantity'),
      quantity: document.querySelector('.MobileModal__QuantityValue'),
      error: document.querySelector('.MobileModal__Error'),
      button: document.querySelector('.MobileModal__Action .Button')
    };
    
    // Update mobile preview
    modal.header.innerHTML = (category.dataset.title != '') ? category.dataset.title : '';
    modal.productTitle.innerHTML = productTitle.innerHTML;
    modal.productSubtitle.innerHTML = product.dataset.subtitle;
    const variantLabel = modal.el.querySelector("[data-configurator-variant-label]");
    if (variantLabel) {
      variantLabel.textContent = product.dataset.variantLabel || "";
      variantLabel.hidden = !product.dataset.variantLabel;
    }
    modal.button.disabled = product.dataset.available === "false";
    modal.gallery.innerHTML = `<img src="${product.dataset.images}" alt="${productTitle.innerHTML}">`;
    modal.quantity.innerHTML = 1;
    modal.error.innerHTML = '';
    modal.button.dataset.variant = product.dataset.variant;
    modal.button.dataset.type = product.dataset.type;
    modal.button.dataset.fill = product.dataset.fill;
    modal.button.dataset.quantity = 1;

    if (product.dataset.type === 'product') {
      modal.quantityWrapper.classList.add('hidden');
    } else {
      modal.quantityWrapper.classList.remove('hidden');
    }
    
    modal.el.classList.add('visible');
    modal.el.setAttribute('aria-hidden', false);
  }

  closeMobilePreview() {
    const modal = document.querySelector('.MobileModal');
    if (modal) {
      modal.classList.remove('visible');
      modal.setAttribute('aria-hidden', true);
    }
  }
}

class Cart {
  constructor() {
    this.cart = window.cart;
    this.element = document.querySelector(".Configurator .Cart");
    this.variants = window.configurator.variants;
    this.errors = [];
    this.cartError = [];
    this.productFill = 0;

    this.cart.stones = [];
    this.cart.charms = [];

    this.render();
    this.validateCart();
    this.addListeners();

    this.clear = function() {
      window.cart.items = [];
      this.cart.items = [];
      this.cart.stones = [];
      this.cart.charms = [];
      

      const products = iEngine.world.bodies.filter(i => i.label !== 'Rectangle Body');
      if (products.length > 0) {
        products.forEach(product => Matter.Composite.remove(iEngine.world, product));
      }

      this.validateIfNextItemCanBeAdded();
      this.render();
      this.validateCart();
      window.csUpdateStep();
    }
  }

  render() {
    this.renderItems();
    this.renderSummary();
  }

  addListeners() {
    this.delegeatedElement = new domDelegate.Delegate(this.element);

    this.delegeatedElement.on(
      "click",
      ".Cart [data-action='decrease-quantity']",
      (event) => {
        const cartItem = event.target.closest(".Cart__Item");
        const variantId = cartItem.dataset.variant;

        this.updateQuantity(variantId, "decrease");
      }
    );

    this.delegeatedElement.on(
      "click",
      ".Cart [data-action='increase-quantity']",
      (event) => {
        const cartItem = event.target.closest(".Cart__Item");
        const variantId = cartItem.dataset.variant;

        this.updateQuantity(variantId, "increase");
      }
    );
  }

  getStonesQuantity() {
    return this.cart.stones.reduce((acc, stone) => {
      return acc + stone.quantity;
    }, 0);
  }

  getCharmsQuantity() {
    return this.cart.charms.reduce((acc, charm) => {
      return acc + charm.quantity;
    }, 0);
  }

  renderSummary() {
    const element = this.element.querySelector(".Cart__Summary");
    element.innerHTML = "";

    const orderPriceElement = document.createElement("div");
    orderPriceElement.classList.add("Cart__Total");
    //add span for mobile drawer
    const orderDrawerElement = document.createElement("span");
    orderDrawerElement.classList.add("Cart__MobileDrawer");
    orderDrawerElement.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.63 6.81"><g fill="none" stroke="#000" stroke-linecap="square" stroke-width=".7"><path d="M.5 6.31 6.32.5"/><path d="m6.31.5 5.82 5.81"/></g></svg>';
    orderPriceElement.appendChild(orderDrawerElement);
    //add span for message
    const orderPriceMessageElement = document.createElement("span");
    orderPriceMessageElement.classList.add("Cart__TotalMessage");
    orderPriceMessageElement.innerText = window.configurator_content.cartTotal;
    orderPriceElement.appendChild(orderPriceMessageElement);
    //add span for price
    const orderPriceValueElement = document.createElement("span");
    orderPriceValueElement.classList.add("Cart__TotalValue");
    orderPriceValueElement.innerText = Currency.formatMoney(
      this.cart.items.reduce((acc, item) => {
        return acc + item.variant.price * item.quantity;
      }, 0),
      settings.moneyFormat
    );
    orderPriceElement.appendChild(orderPriceValueElement);
    element.appendChild(orderPriceElement);

    const shippingInfoElement = document.createElement("p");
    shippingInfoElement.classList.add("Cart__ShippingInfo");
    shippingInfoElement.innerText = window.configurator_content.shipping;
    element.appendChild(shippingInfoElement);

    const checkoutButtonWrapper = document.createElement("div");
    checkoutButtonWrapper.classList.add("Cart__CheckoutButtonWrapper");

    const checkoutButtonElement = document.createElement("button");
    checkoutButtonElement.addEventListener("click", () => {
      this.proceedToCheckout();
    });
    checkoutButtonElement.type = "button";
    checkoutButtonElement.classList.add(
      "Button",
      "Button--primary",
      "Button--full",
      "Button--big",
      "Cart__CheckoutButton"
    );
    checkoutButtonElement.innerText = window.configurator_content.addToCart;

    //create tooltip for button
    const tooltipElement = document.createElement("div");
    tooltipElement.classList.add("Tooltip", "Tooltip--error");
    tooltipElement.role = "tooltip";

    //create tooltip in ner
    const tooltipInnerElement = document.createElement("div");
    tooltipInnerElement.classList.add("Tooltip__Inner");
    tooltipElement.appendChild(tooltipInnerElement);

    const tooltipArrowElement = document.createElement("div");
    tooltipArrowElement.classList.add("Tooltip--arrow");
    tooltipArrowElement.dataset.popperArrow = "";

    tooltipElement.appendChild(tooltipArrowElement);
    checkoutButtonWrapper.appendChild(tooltipElement);
    checkoutButtonWrapper.appendChild(checkoutButtonElement);

    element.appendChild(checkoutButtonWrapper);

    const popperInstance = Popper.createPopper(
      element.querySelector(".Cart__CheckoutButtonWrapper"),
      tooltipElement,
      {
        placement: "top",
        offset: [-12, 0],
      }
    );

    function show() {
      if (!checkoutButtonElement.classList.contains("disabled")) return;
      tooltipElement.setAttribute("data-show", "");
      popperInstance.update();
    }

    function hide() {
      tooltipElement.removeAttribute("data-show");
    }

    document.addEventListener("cartError", (e) => {
      if (e.detail) {
        tooltipElement.querySelector(".Tooltip__Inner").innerText = e.detail.message;
        checkoutButtonElement.classList.add("disabled");
      } else {
        checkoutButtonElement.classList.remove("disabled");
      }
    });

    checkoutButtonElement.addEventListener("mouseenter", show);
    checkoutButtonElement.addEventListener("focus", show);
    checkoutButtonElement.addEventListener("mouseleave", hide);
    checkoutButtonElement.addEventListener("blur", hide);
  }

  renderItems() {
    const element = this.element.querySelector(".Cart__Items");
    element && (element.innerHTML = '');

    this.productFill = 0;
    this.cart.items = [
      ...this.cart.products,
      ...this.cart.stones,
      ...this.cart.charms,
    ];

    this.cart.items.forEach((item) => {
      const product = item.variant;

      const itemElement = document.createElement("div");
      itemElement.classList.add("Cart__Item");

      itemElement.dataset.variant = item.variant.id;
      itemElement.dataset.productType = item.product_type;
      itemElement.dataset.fill = item.fill;
      element.appendChild(itemElement);

      if (item.product_type == "stone" && itemElement.dataset.fill) {
        this.productFill = Number(this.productFill) + Number(itemElement.dataset.fill)*item.quantity;
      }

      const imageWrapper = document.createElement("figure");
      imageWrapper.classList.add("Cart__Image");

      const imageElement = document.createElement("img");
      if (product.featured_image) {
        imageElement.setAttribute("src", product.featured_image.src);
        imageElement.setAttribute("alt", product.title);
        imageWrapper.appendChild(imageElement);
        itemElement.appendChild(imageWrapper);
      }

      const contentElement = document.createElement("div");
      contentElement.classList.add("Cart__Content");

      const nameElement = document.createElement("span");
      nameElement.classList.add("Cart__Name");
      nameElement.innerText = product.product_name;
      contentElement.appendChild(nameElement);

      if (product.color) {
        const colorElement = document.createElement("span");
        colorElement.classList.add("Cart__Color");
        colorElement.innerText = product.color;
        contentElement.appendChild(colorElement);
      }

      const variantLabel = this.element.closest(".Configurator")?.hasAttribute("data-show-variant-labels") &&
        product.title !== "Default Title" ? product.title : "";
      if (product.size || variantLabel) {
        const sizeElement = document.createElement("span");
        sizeElement.classList.add("Cart__Size");
        sizeElement.innerText = product.size || variantLabel;
        contentElement.appendChild(sizeElement);
      }

      if (
        (item.product_type == "stone" &&
          settings.rules.minStones != settings.rules.maxStones) ||
        (item.product_type == "charm" &&
          settings.rules.minCharms != settings.rules.maxCharms)
      ) {
        const quantityElement = document.createElement("div");
        quantityElement.classList.add("Cart__Quantity");

        const quantityPrefixElement = document.createElement("span");
        quantityPrefixElement.classList.add("Cart__QuantityPrefix");
        quantityPrefixElement.innerText = "Ilość";
        quantityElement.appendChild(quantityPrefixElement);

        //crate quantity inner
        const quantityInnerElement = document.createElement("div");
        quantityInnerElement.classList.add("Cart__QuantityInner");

        const minusElement = document.createElement("button");
        minusElement.dataset.action = "decrease-quantity";
        minusElement.classList.add(
          "Cart__QuantityButton",
          "Cart__QuantityMinus"
        );
        minusElement.innerText = "-";
        quantityInnerElement.appendChild(minusElement);

        const quantityValueElement = document.createElement("span");
        quantityValueElement.classList.add("Cart__QuantityValue");
        quantityValueElement.innerText = item.quantity;
        quantityInnerElement.appendChild(quantityValueElement);

        const plusElement = document.createElement("button");
        plusElement.dataset.action = "increase-quantity";
        plusElement.classList.add("Cart__QuantityButton", "Cart__QuantityPlus");
        plusElement.innerText = "+";
        quantityInnerElement.appendChild(plusElement);

        quantityElement.appendChild(quantityInnerElement);
        contentElement.appendChild(quantityElement);
      }

      if (item.product_type != "product" && item.product_type != undefined) {
        const removeElement = document.createElement("button");
        removeElement.setAttribute('type', 'button');
        removeElement.classList.add("Cart__Remove");

        removeElement.innerHTML = `<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">
        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
      </svg>`;

        contentElement.appendChild(removeElement);
        removeElement.addEventListener("click", () => {
          this.remove(item);
        });
      }

      const priceElement = document.createElement("span");
      priceElement.classList.add("Cart__Price");
      priceElement.innerText = Currency.formatMoney(
        product.price,
        settings.moneyFormat
      );
      contentElement.appendChild(priceElement);

      itemElement.appendChild(contentElement);
    });

    this.validateIfNextItemCanBeAdded();
  }

  //used to check if we can proceed to checkout
  validateCart() {
    const checkoutButton = this.element.querySelector(".Cart__CheckoutButton");
    //validate for settings.cart.rules
    const stonesQuantity = this.getStonesQuantity();
    const charmsQuantity = this.getCharmsQuantity();

    try {
      if (stonesQuantity == 0 && charmsQuantity == 0)
        throw new Error(window.configurator_content.addStonesOrCharms);

      if (stonesQuantity < settings.cart.rules.minStones && stonesQuantity > 0)
        throw new Error(
          `${window.configurator_content.minStones} ${settings.cart.rules.minStones}`
        );

      if (charmsQuantity < settings.cart.rules.minCharms && charmsQuantity > 0)
        throw new Error(
          `${window.configurator_content.minCharms} ${settings.cart.rules.minCharms}`
        );

      // if (stonesQuantity > settings.cart.rules.maxStones)
      //   throw new Error(
      //     `${window.configurator_content.maxStones} ${settings.cart.rules.maxStones}`
      //   );

      if (charmsQuantity > settings.cart.rules.maxCharms)
        throw new Error(
          `${window.configurator_content.maxCharms} ${settings.cart.rules.maxCharms}`
        );

      return true;
    } catch (error) {
      const oldError = this.cartError;

      this.cartError = error || null;

      if (this.cartError != oldError) {
        document.dispatchEvent(
          new CustomEvent("cartError", { detail: this.cartError })
        );
      }
    }
  }

  proceedToCheckout() {
    const cartButton = document.querySelector('.Configurator .Cart__CheckoutButton');
    const cartItems = { items: [] };
    const setId = (Math.random() + 1).toString(36).substring(7);

    if (cartButton && cartButton.classList.contains('disabled')) return;

    cartButton.classList.add('loading');

    this.cart.items.forEach(item => {
      cartItems.items.push({
        id: item.variant.id,
        quantity: item.quantity,
        properties: {
          _setId: `#${setId}`,
          _setProducts: this.cart.items.length,
          _setItemType: (item.product_type) ? item.product_type : 'product',
          _setItemQty: item.quantity
        }
      });
    });
    cartItems.items = cartItems.items.reverse();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartItems)
    })
    .then(response => response.json())
    .then(response => {
      if (response.items?.length > 0) {
        window.top.location = '/cart';
      } else {
        alert(response.description);
        cartButton.classList.remove('loading');
      }
      return true;
    })
    .catch((error) => {
      cartButton.classList.remove('loading');
    });
  }

  //used to check if we can add items to cart
  validateUpdate(item) {
    if (item.product_type == "product") return;

    const mobileModal = {
      el: document.querySelector('.MobileModal'),
      error: document.querySelector('.MobileModal__Error')
    };
    const stonesQuantity = this.getStonesQuantity();
    const charmsQuantity = this.getCharmsQuantity();

    if (item.product_type == "stone") {

      if (Number(this.productFill) > 75 || Number(this.productFill) + Number(item.fill)*Number(item.quantity) > 90) {
        (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = window.configurator_content.maxFillStones);
        mobileModal.el.classList.remove("visible");
        this.closeError(mobileModal.error);
        throw new Error(window.configurator_content.maxFillStones);
      }

      if (charmsQuantity > 0) {
        (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = window.configurator_content.removeCharms);
        mobileModal.el.classList.remove("visible");
        this.closeError(mobileModal.error);
        throw new Error(window.configurator_content.removeCharms);
      }
      // if (stonesQuantity + item.quantity > settings.rules.maxStones) {
      //   (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = `${window.configurator_content.maxStones} ${settings.rules.maxStones}`);
      //   mobileModal.el.classList.remove("visible");
      //   this.closeError(mobileModal.error);
      //   throw new Error(`${window.configurator_content.maxStones} ${settings.rules.maxStones}`);
      // }
      if (stonesQuantity + item.quantity < settings.rules.minStones) {
        (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = `${window.configurator_content.minStones} ${settings.rules.minStones}`);
        mobileModal.el.classList.remove("visible");
        this.closeError(mobileModal.error);
        throw new Error(`${window.configurator_content.minStones} ${settings.rules.minStones}`);
      }

      return;
    }

    if (item.product_type == "charm") {
      if (stonesQuantity > 0) {
        (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = window.configurator_content.removeStones);
        mobileModal.el.classList.remove("visible");
        this.closeError(mobileModal.error);
        throw new Error(window.configurator_content.removeStones);
      }
      if (charmsQuantity + item.quantity > settings.rules.maxCharms) {
        (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = `${window.configurator_content.maxCharms} ${settings.rules.maxCharms}`);
        mobileModal.el.classList.remove("visible");
        this.closeError(mobileModal.error);
        throw new Error(`${window.configurator_content.maxCharms} ${settings.rules.maxCharms}`);
      }
      if (charmsQuantity + item.quantity < settings.rules.minCharms) {
        (mobileModal.el.classList.contains('visible')) && (mobileModal.error.innerHTML = `${window.configurator_content.minCharms} ${settings.rules.minCharms}`);
        mobileModal.el.classList.remove("visible");
        this.closeError(mobileModal.error);
        throw new Error(`${window.configurator_content.minCharms} ${settings.rules.minCharms}`);
      }
    }
  }

  closeError(element) {
    element.addEventListener("click", function() {
      element.innerHTML = ''; 
    });
  }

  //used to check if we can add next item to cart
  validateIfNextItemCanBeAdded() {
    let errors = [];
    const stonesQuantity = this.getStonesQuantity();
    const charmsQuantity = this.getCharmsQuantity();

    if (Number(this.productFill) > 75) {
      const error = new Error(`${window.configurator_content.maxFillStones}`);
      error.name = "maxStones";
      errors.push(error);
    }

    // if (stonesQuantity === settings.rules.maxStones) {
    //   const error = new Error(`${window.configurator_content.maxStones} ${settings.rules.maxStones}`);
    //   error.name = "maxStones";
    //   errors.push(error);
    // }

    if (charmsQuantity === settings.rules.maxCharms) {
      const error = new Error(`${window.configurator_content.maxCharms} ${settings.rules.maxCharms}`);
      error.name = "maxCharms";
      errors.push(error);
    }

    //u cant add charms if there are stones
    if (stonesQuantity > 0) {
      const error = new Error(window.configurator_content.removeStones);
      error.name = "removeStones";
      errors.push(error);
    }

    //u cant add stones if there are charms
    if (charmsQuantity > 0) {
      const error = new Error(window.configurator_content.removeCharms);
      error.name = "removeCharms";
      errors.push(error);
    }

    const oldErrors = this.errors;
    this.errors = errors;

    this.errors.forEach((error) => {
      console.log(error.name);
    });

    if (oldErrors.length !== this.errors.length)
      document.dispatchEvent(new Event("errorsChanged"));
  }

  remove(item) {
    const variantId = item.variant.id;
    const productType = item.product_type;

    if (productType == "product") return;

    if (productType == "stone") {
      this.cart.stones = this.cart.stones.filter(
        (item) => item.variant.id != variantId
      );
    }

    if (productType == "charm") {
      this.cart.charms = this.cart.charms.filter(
        (item) => item.variant.id != variantId
      );
    }
    
    if (productType == "stone" || productType == "charm") {
      const products = iEngine.world.bodies.filter(i => i.label === `obj_${item.variant.id}`);
      if (products.length > 0) {
        products.forEach(product => Matter.Composite.remove(iEngine.world, product));
      }
    }

    this.validateIfNextItemCanBeAdded();
    this.render();
    this.validateCart();
    window.csUpdateStep();
  }

  add(item) {
    item.quantity = Number(item.quantity);

    if (this.validateUpdate(item)) {
      // alert(window.configurator_content?.maxFillStones);
      return false;
    }

    item.variant = this.variants.find((v) => v.id == item.variant);

    if (item.product_type == "product") {
      this.cart.products = [
        {
          quantity: item.quantity,
          variant: item.variant,
          product_type: 'product',
          fill: item.fill
        },
      ];
    }

    if (item.product_type == "stone") {
      const itemInCart = this.cart.stones.find(
        (itemInCart) => itemInCart.variant == item.variant
      );

      if (itemInCart) {
        itemInCart.quantity += item.quantity;
      } else {
        this.cart.stones.push(item);
      }
    }

    if (item.product_type == "charm") {
      const itemInCart = this.cart.charms.find(
        (itemInCart) => itemInCart.variant == item.variant.id
      );

      if (itemInCart) {
        itemInCart.quantity += item.quantity;
      } else {
        this.cart.charms.push(item);
      }
    }

    this.validateIfNextItemCanBeAdded();
    this.render();
    this.validateCart();

    if (item.product_type == "product") {
      const nextStep = document.querySelector('.Configurator .Header__Navigation ul li:nth-child(2) a');
      nextStep && nextStep.dispatchEvent(new Event('click'));
    }
    window.csUpdateStep();

    return true;
  }

  updateQuantity(variantId, quantity) {
    const item = { ...this.cart.items.find((v) => v.variant.id == variantId) };
    const itemRef = this.cart.items.find((v) => v.variant.id == variantId);

    if (quantity == "increase") {
      item.quantity = 1;
      this.validateUpdate(item);
    }

    if (quantity == "decrease") {
      item.quantity = -1;
    }

    if (typeof quantity == "number") {
      item.quantity = quantity;
      this.validateUpdate(item);
    }

    if (quantity == "increase" && Number(this.productFill) < 76) {
      itemRef.quantity++;

      const products = iEngine.world.bodies.filter(i => i.label === `obj_${variantId}`);
      if (products.length > 0) {
        drawObject(variantId, (itemRef.quantity - products.length));
      }
    }

    if (quantity == "decrease" && itemRef.quantity > 1) {
      itemRef.quantity--;

      const products = iEngine.world.bodies.filter(i => i.label === `obj_${variantId}`);
      if (products.length > 0) {
        const lastItem = products[products.length - 1]; 
        Matter.Composite.remove(iEngine.world, lastItem);
      }
    }

    if (typeof quantity == "number") {
      itemRef.quantity = quantity;
    }

    if (quantity == "decrease") {
      this.validateIfNextItemCanBeAdded();
    }
    this.render();
    this.validateCart();
    window.csUpdateStep();
  }
}

addEventListener("DOMContentLoaded", () => {
  const cart = new Cart();
  const configurator = new Configurator(cart);
  cart.configurator = configurator;
  window.csCart = cart;

  // Step controls
  window.csUpdateStep = () => {
    const el = {
      currentStep: document.querySelector('.Configurator .Header__Navigation ul li.active'),
      updateStones: document.querySelector('.MainProduct__NavigationBtn--cts'),
      updateNecklace: document.querySelector('.MainProduct__NavigationBtn--ctn'),
      reset: document.querySelector('.MainProduct__NavigationBtn--reset'),
      undo: document.querySelector('.MainProduct__NavigationBtn--undo')
    };
    if (!el.currentStep) return;

    const stepId = Array.from(el.currentStep.parentNode.children).indexOf(el.currentStep);
    switch (stepId) {
      case 0:
        el.updateStones.classList.remove('hidden');
        el.updateNecklace.classList.add('hidden');
        if (window.csCart.cart.items.length > 1) {
          el.reset.classList.remove('hidden');
          el.undo.classList.remove('hidden');
        } else {
          el.reset.classList.add('hidden');
          el.undo.classList.add('hidden');
        }
        break;
      case 1:
        el.updateStones.classList.add('hidden');
        el.updateNecklace.classList.remove('hidden');
        if (window.csCart.cart.items.length > 1) {
          el.reset.classList.remove('hidden');
          el.undo.classList.remove('hidden');
        } else {
          el.reset.classList.add('hidden');
          el.undo.classList.add('hidden');
        }
        break;
      case 2:
        el.updateStones.classList.add('hidden');
        el.updateNecklace.classList.remove('hidden');
        if (window.csCart.cart.items.length > 1) {
          el.reset.classList.remove('hidden');
          el.undo.classList.remove('hidden');
        } else {
          el.reset.classList.add('hidden');
          el.undo.classList.add('hidden');
        }
        break;
      default:
        el.updateStones.classList.add('hidden');
        el.updateNecklace.classList.add('hidden');
        el.reset.classList.add('hidden');
        el.undo.classList.add('hidden');
    }
  };

  // Tab navigation
  const tabs = document.querySelectorAll(".Configurator .Header li a");
  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      const tab = e.target;
      const tabName = tab.getAttribute("href").replace("#", "");

      if (tab.closest("li").classList.contains("active")) return;

      document.querySelector(".Configurator .Header li.active").classList.remove("active");
      tab.closest("li").classList.add("active");
      document.querySelector(".Configurator .Sidebar--left.active").classList.remove("active");

      const sidebarHeader = document.querySelector(`.Configurator .Sidebar--leftWrapper .Sidebar__Header[id="${tabName}"]`);
      const sidebar = sidebarHeader.closest(".Sidebar--left");
      sidebar.classList.add("active");
      sidebar.scrollTo({
        top: sidebarHeader.offsetTop,
        behavior: "smooth",
      });

      // Mobile navigation
      const mobileTabs = document.querySelectorAll('.MobileProducts__Category');

      if (mobileTabs.length > 0) {
        mobileTabs.forEach(mobileTab => {
          mobileTab.classList.remove('active');
          (mobileTab.dataset.tab === tabName) && mobileTab.classList.add('active');
        });
      }

      window.csUpdateStep();
    });
  });

  document.querySelector('.js-close-app').addEventListener('click', () => {
    document.querySelector('.close-confirm').setAttribute('aria-hidden', false)
  })

  document.querySelector('.js-close-app-mobile').addEventListener('click', () => {
    document.querySelector('.close-confirm').setAttribute('aria-hidden', false)
  })

  document.querySelectorAll('.close-modal').forEach((close)=>{
    close.addEventListener('click', () => {
      document.querySelector('.close-confirm').setAttribute('aria-hidden', true)
    })
  })
});
